import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getWarehouseApi,
  warehousCuApi,
  warehouseDisableRestoreApi,
} from "../../../apiservice/setting";

// Fetch warehouses
export const fetchWarehousesList = createAsyncThunk(
  "warehouses/fetchWarehousesList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getWarehouseApi(null);
      return res.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Create or Update
export const createOrUpdateWarehouse = createAsyncThunk(
  "warehouses/createOrUpdateWarehouse",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await warehousCuApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Delete or Disable/Restore
export const deleteWarehouse = createAsyncThunk(
  "warehouses/deleteWarehouse",
  async (id, { rejectWithValue }) => {
    try {
      const res = await warehouseDisableRestoreApi({ id, action: "disable" });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
